import { useState } from 'react';
import { EpiEditData } from '@api/types';

/**
 * Get Epi edit mode data
 * @returns EpiData Epi data
 */

export const useEditMode = () => {
  const [epi, setEpi] = useState(window.epi || {});

  // Return if not inside of EPI Server Back Office
  if (!inEpiShell()) {
    return { inEpiShell: false, ready: true, subscribe: () => null } as EpiEditData;
  }

  /**
   * Subscribe to event
   */
  const subscribe = (eventName: string, handler: Function) => {
    if (epi.subscribe && typeof epi.subscribe === 'function') {
      epi.subscribe(eventName, handler);
    } else {
      window.addEventListener('load', () => {
        window.epi.subscribe(eventName, handler);
      });
    }
  };

  let interval: any;
  if (!interval && !window.epi?.ready) {
    interval = setInterval(() => {
      if (window.epi && window.epi?.ready) {
        setEpi(window.epi);
        clearInterval(interval);
      }
    }, 200);
  }

  return {
    ...epi,
    subscribe,
    inEpiShell: inEpiShell(),
    inCompareLeftPane: inCompareLeftPane(),
    inCompareRightPane: inCompareRightPane(),
    ...window.epiBlock,
  } as EpiEditData;
};

/**
 * Check if site is displayed inside EPI Server iframe
 */
export const inEpiShell = () => {
  try {
    return window !== window?.top;
  } catch (e) {
    // Ignored on purpose
  }
  return false;
};

export const inCompareLeftPane = () => {
  return window?.name === 'compareView';
};

export const inCompareRightPane = () => {
  try {
    const parent = window.parent;
    if (window === parent) {
      return false;
    }
    const leftPane = parent.document.querySelector('iframe[name=compareView');
    return Boolean(leftPane && !inCompareLeftPane());
  } catch (e) {
    return false;
  }
};

export const useEditModeLinks = () => {
  return {
    getEditContentLink: (contentId?: number) =>
      contentId ? `/episerver/cms#context=epi.cms.contentdata:///${contentId}` : '',
  };
};
